import { render, staticRenderFns } from "./GoldCard.vue?vue&type=template&id=cfd3e250&scoped=true"
import script from "./GoldCard.vue?vue&type=script&lang=ts"
export * from "./GoldCard.vue?vue&type=script&lang=ts"
import style0 from "./GoldCard.vue?vue&type=style&index=0&id=cfd3e250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd3e250",
  null
  
)

export default component.exports